import React, { useRef, useState, useEffect } from 'react';
import { Reveal } from './TerminalEffects';

const StatItem = ({ value, suffix, label, visible, delay }) => {
  const [count, setCount] = useState(0);
  const started = useRef(false);
  useEffect(() => {
    if (!visible || started.current) return;
    started.current = true;
    const st = performance.now();
    const step = (t) => {
      const p = Math.min((t - st) / 2200, 1);
      setCount(Math.floor((1 - Math.pow(1 - p, 3)) * value));
      if (p < 1) requestAnimationFrame(step); else setCount(value);
    };
    requestAnimationFrame(step);
  }, [value, visible]);

  return (
    <div className="text-center transition-all duration-700"
      style={{ transitionDelay: `${delay}ms`, opacity: visible ? 1 : 0, transform: visible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)' }}>
      <p className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#2A2A2A] leading-none"
        style={{ fontFamily: "'Outfit', sans-serif" }}>
        {count.toLocaleString()}{suffix}
      </p>
      <p className="text-xs sm:text-sm font-mono uppercase tracking-[0.15em] text-[#C4956A] mt-3">{label}</p>
    </div>
  );
};

const STATS = [
  { value: 10000, suffix: '+', label: 'Calls Handled' },
  { value: 50, suffix: '+', label: 'Businesses' },
  { value: 98, suffix: '%', label: 'Satisfaction' },
  { value: 24, suffix: '/7', label: 'Availability' },
];

export const StatsCounter = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-24 lg:py-32 bg-[#FAF8F4] overflow-hidden" data-testid="stats-section">
      {/* Animated divider line */}
      <div className="relative h-px w-full max-w-[1200px] mx-auto overflow-hidden mb-12">
        <div className="h-full transition-all duration-1000 ease-out"
          style={{ width: visible ? '100%' : '0%', background: 'linear-gradient(90deg, transparent, rgba(0,255,209,0.3), transparent)' }} />
      </div>
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C4956A] mb-4 text-center">By the Numbers</p>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6 mt-12">
          {STATS.map((s, i) => (
            <StatItem key={s.label} value={s.value} suffix={s.suffix} label={s.label} visible={visible} delay={i * 200} />
          ))}
        </div>
      </div>
    </section>
  );
};
